import { CashPlan } from "../../common/Constants";

export const tableColumns = [
  {
    name: "indentNo",
    label: "No. Indent",
  },
  {
    name: "indentDate",
    label: "Tgl. Indent",
  },
  {
    name: "customerName",
    label: "Nama Konsumen",
  },
  {
    name: "customerKTPNumber",
    label: "NIK KTP",
  },
  {
    name: "dataVarian.kodeVariant",
    label: "Kd. Var",
  },
  {
    name: "dataVarian.namaVariant",
    label: "Nm. Varian",
  },
  {
    name: "dataWarna.kodeWarna",
    label: "Kd. Wrn",
  },
  {
    name: "dataWarna.namaWarnaKomersil",
    label: "Nm. Warna",
  },
  {
    name: "ageIndetUnit",
    label: "Umur",
  },
];

export const searchOptions = [
  {
    label: "Nama Varian",
    value: "Nama Varian",
  },
  {
    label: "Kode Varian",
    value: "Kode Varian",
  },
];

export const cashPlanOptions = [
  {
    label: CashPlan.CASH,
    value: CashPlan.CASH,
  },
  {
    label: CashPlan.CREDIT,
    value: CashPlan.CREDIT,
  },
];

export const indentDepositOptions = [
  {
    label: "YES",
    value: true,
  },
  {
    label: "NO",
    value: false,
  },
];
